import React, { useEffect, useState } from 'react';
import { Wrapper, TopWrapper } from './styled';
import ActionBar from './components/ActionBar';
import Tabs from './components/Tabs';
import { resetState, setPageUserAgents } from 'store/Agents/actions';
import { useDispatch, useSelector } from 'react-redux';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import { MODAL_AGENT_DETAIL, MODAL_AGENT_EXECUTOR_DETAIL, MODAL_AGENT_TRIGGER_WARNING, MODAL_UPGRADE_LICENSE_CLOUD_AGENTS } from 'store/modals/modals';
import ReduxModal from 'Common/Components/ReduxModal';
import FFCloudAgents from 'Images/ff_cloud_agents.png';
import { AGENTS } from './components/Tabs/constants';
import VisualModeButton from './components/VisualModeButton';
import Content from './components/Content';
import { closeModal, openModal } from 'store/modals/actions';
import { selectShowGridView } from 'store/Filters/selectors';
import { setShowGridView } from 'store/Filters/actions';
import selectModal from 'store/modals/selectors';
import { SelectShowCloudAgents } from 'store/Agents/selectors';

const Agents = () => {
  const dispatch = useDispatch();
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const [selectedTab, setSelectedTab] = useState(AGENTS);

  const entity = showCloudAgents ? 'cloudAgents' : 'agents';
  const showGridView = useSelector((state) => selectShowGridView(entity, state));
  const showAgentDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const showTriggerWarning = useSelector((state) => selectModal(state, MODAL_AGENT_TRIGGER_WARNING));
  const toggleAgents = () => dispatch(openModal(MODAL_UPGRADE_LICENSE_CLOUD_AGENTS));

  const toggleView = () => {
    dispatch(setShowGridView(entity, !showGridView));
    dispatch(setPageUserAgents(1));
  };

  useEffect(() => () => {
    dispatch(resetState());
  }, [dispatch]);

  useEffect(() => () => {
    dispatch(closeModal(MODAL_AGENT_DETAIL));
    dispatch(closeModal(MODAL_AGENT_EXECUTOR_DETAIL));
  }, [dispatch, selectedTab]);

  return (
    <Wrapper>
      <ReduxModal id={ MODAL_UPGRADE_LICENSE_CLOUD_AGENTS }>
        <UpgradeLicense id={ MODAL_UPGRADE_LICENSE_CLOUD_AGENTS } image={ FFCloudAgents } descriptionIntlId={ 'upgradeLicense.sidebar.cloudAgents.description' } />
      </ReduxModal>
      <TopWrapper>
          <Tabs onToggleAgents={ toggleAgents } selectedTab={ selectedTab } setSelectedTab={ setSelectedTab } />
          <VisualModeButton seletedTab={ selectedTab } showGridView={ showGridView } toggleView={ toggleView } />
      </TopWrapper>
      <ActionBar selectedTab={ selectedTab } showCloudAgents={ showCloudAgents } />
      <Content showGridView={ showGridView } selectedTab={ selectedTab } showAgentDetail={ showAgentDetail } showTriggerWarning={ showTriggerWarning } />
    </Wrapper>
  );
};

export default Agents;
